import React, {useEffect,useMemo} from 'react'
import { shallowEqual,useDispatch,useSelector} from 'react-redux'
import { DetailCard } from '@tecuity/granite-ui/DetailCard'
import { DetailList } from '@tecuity/granite-ui/DetailList'
import { getOrderRecordData, addOrderNote, editOrderNote, deleteOrderNote } from './OrderRecordDetailActions'
import NotesPanel from '../NotesPanel'
import { useLocation } from 'react-router'

/*
Permissions needed when built:
CERTIFICATION_EDIT		Can edit a certification
CERTIFICATION_VOID		Void button is enabled
*/

const DataRequestRecordDetails = () => {
    const location = useLocation()
    const dispatch = useDispatch();
    const {appUserRights} = useSelector((state) => state.auth, shallowEqual);


    const { recordDetails} = useSelector((state) => state.record, shallowEqual)

    const fileNum = useMemo(() => {
        const parts = location.pathname.split('/')
        return parts[parts.length - 1]
        }, [location.pathname])

    useEffect(() => {
        dispatch(getOrderRecordData(fileNum))
    }, [fileNum])

    const saveNewNote = (note) => {
        dispatch(addOrderNote(note, fileNum))
    }

    const editNote = (note) => {
        dispatch(editOrderNote(note, fileNum))
    }

    const deleteNote = (noteId) => {
        dispatch(deleteOrderNote(noteId, fileNum))
    }

if(!appUserRights.includes('CERTIFICATION_VIEW')){
    return(
    <div style={{fontWeight: 'bolder', fontSize: 16, textAlign: 'center'}}>
        You do not have the rights to view this record. Contact your system adminstrator if you think this is in error.
    </div>)
    }

return(
    <div>
        <div className="row" style={{ display: 'flex', flexDirection: 'row', gap: '20px', paddingBottom: '10px' }}>
            <DetailCard className="detailsCard" label="General Details" customCss={{ flexGrow: 2 }}>
                <DetailList
                    className="detailsList"
                    details={[
                        {'label':'Record Type','value':recordDetails.SourceType},
                        {'label':'Record #','value':recordDetails.RecordNumber},
                        {'label':'Certification Type','value':recordDetails.CertRecordType},
                        {'label':'Requestor Type','value':recordDetails.RequestorType},
                        {'label':'Requestor Name','value':recordDetails.RequestorName},
                        {'label':'Status','value':recordDetails.Status},
                        {'label':'Record Date','value': recordDetails.RecordDate ? recordDetails.RecordDate.substr(0,recordDetails.RecordDate.indexOf('T')) : ''},
                        {'label':'DLN','value':recordDetails.DLN},
                        {'label':'Number of Copies','value':recordDetails.NumberOfCopies},
                        ]}
                    topBorder="true" 
                    bottomBorder="true" />
            </DetailCard>

            <DetailCard className="detailsCard" label="Address" customCss={{ flexGrow: 2 }}>
                <DetailList
                    className="detailsList"
                    label="Principal Address"
                    details={
                    [
                        {"label":"Address","value":recordDetails.Address ? recordDetails.Address.AddressLine1 : '' },
                        {"label":"STE/APT/FL","value":recordDetails.Address ? recordDetails.Address.AddressLine2 : ''},
                        {"label":"Attention","value":recordDetails.Address ? recordDetails.Address.AddressLine3 : ''},
                        {"label":"City","value":recordDetails.Address ? recordDetails.Address.City : ''},
                        {"label":"State","value":recordDetails.Address ? recordDetails.Address.State : ''},
                        {"label":"Country","value":recordDetails.Address ? recordDetails.Address.Country : ''},
                        {"label":"Zip","value":recordDetails.Address ? recordDetails.Address.PostalCode : ''}
                    ]
                    }
                    topBorder="true" 
                    bottomBorder="true"
                />
            </DetailCard>
        </div>
    <NotesPanel saveNote={saveNewNote} editNote={editNote} deleteNote={deleteNote} />
    </div>);
}

export default DataRequestRecordDetails;